import React, { useState } from 'react';
import { WorkflowState } from '../../../models/enums/WorkflowState';
import WorkflowStateBadge from '../../common/WorkflowStateBadge';
import './ProgressBarSmall.css';

interface ProgressBarSmallProps {
	workflowState?: WorkflowState;
	porScope: string;
}

const ProgressBarSmall = ({ workflowState, porScope }: ProgressBarSmallProps) => {
	const [showTooltip, setShowTooltip] = useState(false);
	const getFirstBulletClass = () => {
		if (!workflowState) return '';
		switch (workflowState.value) {
			case WorkflowState.Review.value:
			case WorkflowState.Draft.value:
				return 'circle-yellow';
			case WorkflowState.PendingForDOAGApproval.value:
				return '';
			case WorkflowState.Cancelled.value:
			case WorkflowState.Rejected.value:	
				return 'circle-red';
			default:
				return 'back-blue';
		}
	};

	const getSecondBulletClass = () => {
		if (!workflowState) return '';
		switch (workflowState.value) {
			case WorkflowState.Review.value:
			case WorkflowState.Draft.value:
			case WorkflowState.PendingForDOAGApproval.value:
			case WorkflowState.Cancelled.value:
			case WorkflowState.Rejected.value:
				return '';
			case WorkflowState.PendingForPolicyTeamApproval.value:
			case WorkflowState.PendingSolutionArchitectureApproval.value:
			case WorkflowState.PendingProxyArchitectApproval.value:
				return 'circle-yellow';
			default:
				return 'back-blue';
		}
	};

	const getThirdBulletClass = () => {
		if (!workflowState) return '';
		switch (workflowState.value) {
			case WorkflowState.Review.value:
			case WorkflowState.Draft.value:
			case WorkflowState.PendingForDOAGApproval.value:
			case WorkflowState.PendingForPolicyTeamApproval.value:
			case WorkflowState.PendingSolutionArchitectureApproval.value:
			case WorkflowState.PendingProxyArchitectApproval.value:
			case WorkflowState.Cancelled.value:
			case WorkflowState.Rejected.value:
				return '';
			case WorkflowState.PendingForCyberApproval.value:
			case WorkflowState.PendingAppEndorserApproval.value:
			case WorkflowState.PendingOTCRMApproval.value:
			case WorkflowState.PendingConnOwnerApproval.value:
			case WorkflowState.PendingForCloudNetworkApproval.value:
				return 'circle-yellow';
			default:
				return 'back-blue';
		}
	};

	const getLastBulletClass = () => {
		if (!workflowState) return '';
		switch (workflowState.value) {
			case WorkflowState.AwaitingImplementation.value:
				return 'circle-yellow';
			case WorkflowState.Error.value:
			case WorkflowState.ImplementationFailed.value:
				return 'circle-red';
			case WorkflowState.Completed.value:
				return 'circle-green';
			default:
				return '';
		}
	};

	return (
		<div
			className="progress"
			onMouseEnter={() => setShowTooltip(true)}
			onMouseLeave={() => setShowTooltip(false)}
			title=""
		>
			{showTooltip && workflowState && (
				<div className="tooltip">
					<WorkflowStateBadge fullWidth workflowState={workflowState} />
				</div>
			)}
			<div className="progress-bar-line" />
			<div className={`circle ${getFirstBulletClass()} left-0`} />
			<div className={`circle ${getSecondBulletClass()} left-33`} />
			<div className={`circle ${getThirdBulletClass()} left-66`} />
			<div className={`circle ${getLastBulletClass()} left-100`} />
		</div>
	);
};

export default ProgressBarSmall;
